export interface BaseInvestmentProduct {
  id?: string;
  productType?: string;
  nombreProducto: string;
  razonSocial: string;
  cifNif: string;
  direccion?: string;
  domicilioSocial?: string;
  ibanRecaudacion?: string;
  bic?: string;

  // Control Admin (calculados)
  inversionesVigentes?: number;
  ticketsVivos?: number;
  inversoresActivos?: number;
  fechaUltimaCaptacion?: string;
  fechaUltimoPago?: string;
  proximaComunicacion?: string;

  // Auditoria
  active?: boolean;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface CrvProduct extends BaseInvestmentProduct {
  // Campos específicos CRV
  capObjetivoGlobal?: number;
  estadoGlobal?: string;
  frecuenciaPago?: string;

  // Métricas Capital (calculados)
  capitalCaptado?: number;
  capitalDevuelto?: number;
  capitalVivo?: number;
  capObjetivoCubierto?: number;

  // Métricas Interés (calculados)
  interesPrevisto?: number;
  interesPagado?: number;
  interesDevengadoNoPagado?: number;
  porcentajeInteresPagado?: number;
  proximoPagoInteres?: string;
}

export interface CraProduct extends BaseInvestmentProduct {
  // Campos específicos CRA
  ticketsObjetivo?: number;
  valorContableActual?: number;
  estadoSociedad?: string;

  // Valoración (calculados)
  valorEstimado?: number;
  plusvaliaEstimada?: number;
  porcentajePlusvalia?: number;

  // Métricas Capital (calculados)
  capitalCaptado?: number;
  capitalDevuelto?: number;
  capitalVivo?: number;
  ticketsCubierto?: number;

  // Métricas Salida (calculado)
  importeEstimadoSalida?: number;
}

export interface PhProduct extends BaseInvestmentProduct {
  // Campos específicos PH
  estadoGlobal?: string;
  capObjetivoGlobal?: number;
  frecuenciaPago?: string;

  // Métricas Capital (calculados)
  capitalCaptado?: number;
  capitalDevuelto?: number;
  capitalVivo?: number;
  capObjetivoCubierto?: number;

  // Métricas Interés (calculados)
  interesPrevisto?: number;
  interesPagado?: number;
  interesDevengadoNoPagado?: number;
  porcentajeInteresPagado?: number;
  proximoPagoInteres?: string;
}

export type InvestmentProduct = CrvProduct | CraProduct | PhProduct;

export type ProductType = 'crv' | 'cra' | 'ph';

export const PRODUCT_TYPE_LABELS: Record<ProductType, string> = {
  crv: 'Total con Anticipos (CRV)',
  cra: 'Participativo (CRA)',
  ph: 'Renta Fija (PH)',
};

export const ESTADO_GLOBAL_OPTIONS = [
  { value: 'En Captación', label: 'En Captación' },
  { value: 'Captado', label: 'Captado' },
  { value: 'En Devolución', label: 'En Devolución' },
  { value: 'Cerrado', label: 'Cerrado' },
];

export const ESTADO_SOCIEDAD_OPTIONS = [
  { value: 'Activa', label: 'Activa' },
  { value: 'En Liquidación', label: 'En Liquidación' },
  { value: 'Liquidada', label: 'Liquidada' },
];
